import Vue from 'vue'
import VueRouter from 'vue-router'
import PC from '../views/web/Index.vue'
import mobile from '../views/mobile/Index.vue'
import cpp1 from '../views/cpp/Cpp1.vue'
import cpp2 from '../views/cpp/Cpp2.vue'
import cpp3 from '../views/cpp/Cpp3.vue'
import cpp4 from '../views/cpp/Cpp4.vue'
import cpp5 from '../views/cpp/Cpp5.vue'
import cpp6 from '../views/cpp/Cpp6.vue'
import cpp7 from '../views/cpp/Cpp7.vue'
import cpp8 from '../views/cpp/Cpp8.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index.html',
    redirect: '/'
  },
  {
    path: '/',
    name: 'PC',
    component: PC
  },
  {
    path: '/mobile/',
    name: 'mobile',
    component: mobile
  },
  {
    path: '/cpp/01a',
    name: 'cpp1',
    component: cpp1
  },
  {
    path: '/cpp/01b',
    name: 'cpp2',
    component: cpp2
  },
  {
    path: '/cpp/02a',
    name: 'cpp3',
    component: cpp3
  },
  {
    path: '/cpp/02b',
    name: 'cpp4',
    component: cpp4
  },
  {
    path: '/cpp/03a',
    name: 'cpp5',
    component: cpp5
  },
  {
    path: '/cpp/03b',
    name: 'cpp6',
    component: cpp6
  },
  {
    path: '/cpp/04a',
    name: 'cpp7',
    component: cpp7
  },
  {
    path: '/cpp/05a',
    name: 'cpp8',
    component: cpp8
  },
  {
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let uriSearch = window.location.search;
  let docEl = document.documentElement;
  let clientWidth = docEl.clientWidth;
  let clientH = docEl.clientHeight;
  if (!clientWidth) { 
      return
  }

  if(clientWidth < 751 || clientWidth < clientH){
    if(to.path === '/') {
      next('/mobile/' + uriSearch)
    }
  }else{
    if(to.path === '/mobile/') {
      next('/' + uriSearch)
    }
  }

  next()
})

export default router
